export default __webpack_public_path__ + "static/media/Irrigation.d6d67cef.webp";